class StorageService {
  constructor() {
    this.storage = window.localStorage;
    this.accessTokenKey = 'SIX-API:AccessToken';
    this.refreshTokenKey = 'SIX-API:RefreshToken';
    this.uuidKey = 'SIX-API:Client-UUID';
    this.linkUuidKey = 'SIX-API:Client-Link.UUID';
  }

  setAccessToken(accessToken) {
    if (accessToken) {
      this.storage.setItem(this.accessTokenKey, accessToken);
    }
  }

  getAccessToken() {
    return this.storage.getItem(this.accessTokenKey) || false;
  }

  setRefreshToken(refreshToken) {
    if (refreshToken) {
      this.storage.setItem(this.refreshTokenKey, refreshToken);
    }
  }

  getRefreshToken() {
    return this.storage.getItem(this.refreshTokenKey) || false;
  }

  setUuid(uuid) {
    if (uuid) {
      this.storage.setItem(this.uuidKey, uuid);
    }
  }

  getUuid() {
    return this.storage.getItem(this.uuidKey) || false;
  }

  setLinkUuid(linkUuid) {
    if (linkUuid) {
      this.storage.setItem(this.linkUuidKey, linkUuid);
    }
  }

  getLinkUuid() {
    return this.storage.getItem(this.linkUuidKey) || false;
  }

  clearStorage() {
    this.storage.clear();
  }
}

export default new StorageService();
